import * as React from 'react';

import * as styles from './OfficesList.css';

interface IOfficesListProps {
  children: React.ReactNode;
}

export const OfficesList: React.FC<IOfficesListProps> = ({ children }) => {
  return <div className={styles['list']}>{children}</div>;
};
